import { render, staticRenderFns } from "./ProdutosFornecedorCodigoInterno.vue?vue&type=template&id=22dc3e66"
import script from "./ProdutosFornecedorCodigoInterno.vue?vue&type=script&lang=js"
export * from "./ProdutosFornecedorCodigoInterno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports